export const tealiumConfig = {
	account: 'taxhawk',
	profile: 'main',
	environment: process.env.VUE_APP_TEALIUM_ENV || 'dev',
}
